import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const dashboardSearchStyle = (theme) => ({
	searchSection: {
		backgroundColor: whiteColor,
	},
	userAndSearch: {
		paddingTop: '16px',
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column-reverse',
			paddingTop: '20px',
		},
	},
	searchContainer: {
		width: '100%',
		marginBottom: '24px',
	},
	userContainer: {
		marginBottom: '24px',
		width: '100%',
	},
	userName: {
		textTransform: 'capitalize',
	},
});

export default dashboardSearchStyle;
